import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@material-ui/core";
import axios from "../../axios";
import React, { useEffect, useState } from "react";
import { toast, Slide } from "react-toastify";
import CloseIcon from "@material-ui/icons/Close";
import "./Twostep.css";
import "react-toastify/dist/ReactToastify.css";
import logo from "../../assets/images/custom-logo.png"
toast.configure();
const Twoauthverify = ({ data, setUser }) => {
  const [code, setCode] = useState("");
  const [open, setOpen] = useState(false);
  const [is2FAVerified, setIs2FAVerified] = useState(false);

  useEffect(() => {
 
    axios
      .get(`employee_twofactor_auth?EmpId=eq.${data.data?.login}&IsActive=eq.Y`)
      .then((res) => {
        if (res.data.length !== 0) {
       
          setOpen(true);
        } else {
         
          setUser(data.data?.login);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, [data.data?.login, setUser]);

  const verifyCode = (e) => {
    e.preventDefault();
    const verifys = {
      EmpId: data.data.login,
      Verification: true,
      VerificationCode: code,
      Token: data.data.Token,
    };

    axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/twofactauth`, JSON.stringify(verifys))
      .then((res) => {
        if (res.data.msg === "Verification Success") {
          localStorage.setItem("userdata", JSON.stringify(data.data));
          setIs2FAVerified(true); 
          setUser(data?.data.login);

          toast.success("Successfully Logged In", {
            transition: Slide,
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            draggable: true,
          });

          setOpen(false); 
        } else {
          toast.error("Invalid Verification Code", {
            transition: Slide,
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 5000,
            draggable: true,
          });
        }
      })
      .catch((err) => {
        toast.error("Login Failed", {
          transition: Slide,
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 5000,
          draggable: true,
        });
        console.error(err);
      });
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={() => {
          if (is2FAVerified) setOpen(false); 
          toast.error("You must complete two-factor authentication to proceed.", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 3000,
            draggable: true,
          });
        }}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>
          <div className="row">
            <div className="col-5 header_style">
              <strong>Two-Step Auth</strong>
            </div>
            <div className="col-5"></div>
            <div className="col-2">
              <IconButton
                onClick={() => {
                  if (is2FAVerified) setOpen(false); 
                  toast.error("You must complete two-factor authentication to proceed.", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000,
                    draggable: true,
                  });
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="row">
              <div className="col-lg-6 col-md-6">
                <img src={logo} alt="logo" className="pt-2" width={350} />
              </div>
              <div className="col-lg-5 col-md-6">
                <strong>Welcome back</strong>
                <p>{data?.login}</p>
                <small className="blockquote-footer pt-2">
                  Two-factor authentication token
                </small>
                <form onSubmit={verifyCode} className="py-2">
                  <input
                    className="form-control"
                    type="number"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                  />
                  <input type="checkbox" />{" "}
                  <small> Don't ask again on this computer </small>
                  <div className="row pt-3 ml-5">
                    <div className="col-md-6"></div>
                    <div className="col-md-6">
                      <button type="submit" className="btn btn-primary">
                        Login
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};


export default Twoauthverify;

